module.exports = __webpack_public_path__ + "static/media/up.fec18711.svg";